import { Layout as AntLayout, Button, Flex, Result, Typography } from "antd";
import styled from 'styled-components';
import { Outlet } from "react-router";
import { useLogto } from "@logto/react";
import './index.css';
import { LayoutSider } from "./components/LayoutSider";
import { LoginOutlined, RobotFilled, SafetyCertificateOutlined, SyncOutlined } from "@ant-design/icons";
import { usePermission } from "./hooks/usePermission";
import useAutoLogin from "./hooks/useAutoLogin";
import { useAgentStateSync } from "./hooks/useAgentStateSync";
import { useSessionStateSync } from "./hooks/useSessionStateSync";
import { useUserClaims } from "./hooks/useUserClaims";

const Layout = styled(AntLayout)`
  min-height: 100vh;
  background: transparent;
  .app-content {
    height: 100vh;
    overflow: auto;
    padding: 28px 32px 48px;
    box-sizing: border-box;
  }
  .app-menu {
    width: 100%;
    background: transparent;
    border-inline-end: 0;
  }
  @media (max-width: 768px) { .app-content { padding: 20px 16px 40px; } }
`;

export const BaseLayout: React.FC = () => {
  const { isAuthenticated, signIn } = useLogto();
  const { permission } = usePermission();
  const { autoSignIn } = useAutoLogin();
  const [claims] = useUserClaims();
  useAgentStateSync();
  useSessionStateSync();
  if (!isAuthenticated) {
    return (
      <Layout>
        <Flex className="login-shell" vertical align="center" justify="center">
          <Flex className="login-card" vertical align="center">
            <Flex className="login-mark" align="center" justify="center"><RobotFilled /></Flex>
            <Typography.Text className="page-eyebrow">AUTOMATION HUB</Typography.Text>
            <Typography.Title level={1}>欢迎回来</Typography.Title>
            <Typography.Paragraph type="secondary">登录后管理你的执行节点、浏览器会话与自动化任务。</Typography.Paragraph>
            <Button
              block
              type="primary"
              icon={<LoginOutlined />}
              size="large"
              onClick={() => signIn({ redirectUri: `${window.origin}/callback` })}
            >
              使用 Logto 登录
            </Button>
            <Typography.Text className="login-security" type="secondary"><SafetyCertificateOutlined /> 安全身份验证</Typography.Text>
          </Flex>
        </Flex>
      </Layout>
    );
  }
  if (permission.size === 0) {
    return (
      <Layout>
        <Flex vertical align="center" justify="center">
          <Result
            style={{ height: '100vh' }}
            status={403}
            title={'暂无权限'}
            subTitle={(
              <Typography.Text type="secondary">请将你的用户 ID: <Typography.Text strong>{claims?.sub}</Typography.Text> 提供给管理员。</Typography.Text>
            )}
            extra={
              <Button icon={<SyncOutlined />} onClick={() => autoSignIn()}>重新登录</Button>
            }
          />
        </Flex>
      </Layout>
    );
  }
  return (
    <Layout>
      <LayoutSider />
      <Layout.Content className="app-content">
        <Outlet />
      </Layout.Content>
    </Layout>
  );
}
